import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, NgModule, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface UserData {
  checkbox: any;
  name: string;
  email: string;
}

@Component({
  selector: 'app-add-recipient-dialogbox',
  templateUrl: './add-recipient-dialogbox.component.html',
  styleUrls: ['./add-recipient-dialogbox.component.scss']
})
export class AddRecipientDialogboxComponent implements OnInit, AfterViewInit, OnDestroy {

  displayedColumns: string[] = ['checkbox', 'name', 'email'];
  dataSource: MatTableDataSource<UserData>;
  searchValue: string;
  examineeScehduleData: any;

  examineeFilterSubscription$: Subscription

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(public dialogRef: MatDialogRef<AddRecipientDialogboxComponent>, private webErrorService: WebErrorService,
    @Inject(MAT_DIALOG_DATA) public dialogboxData, private testService: TestService, private notificationService: NotificationService,
    public translate: TranslateService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.dialogboxData.data);

    // this.testService.getExamineetoSchedule().subscribe((resData) => {
    //   this.examineeScehduleData = resData?.items;
    //   Array.from(this.dialogboxData).forEach((result: any) => {
    //     const index = this.examineeScehduleData.findIndex((id: any) => {
    //       return result?.examineeId === id?.examineeId;
    //     });
    //     resData.items.splice(index, 1);
    //   });
    //   this.dataSource = new MatTableDataSource<any>(resData?.items);
    // })

    // this.dataSource = new MatTableDataSource(this.examineeScehduleData);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.setPaginatorTranslation(this.dataSource)
    this.dataSource.sort = this.sort;
    this.cdr.detectChanges();
  }


  applyFilter() {
    // const filterValue = this.searchValue;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    // }

    this.examineeFilterSubscription$ =
    this.testService.getFilterExamineetoSchedule(this.searchValue).subscribe((resData)=>{
      if (this.dialogboxData.selected.length > 0) {
        this.dialogboxData.selected?.forEach(element => {
          let b = resData.items.findIndex((x) => x.examineeuuid === element?.examineeuuid);
          resData.items[b].checked = true;
        })
      }

      this.dataSource = new MatTableDataSource(resData.items);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }

  resetFilter() {
    this.searchValue = '';
    // const filterValue = this.searchValue;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    // }
    this.dataSource = new MatTableDataSource(this.dialogboxData.data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  addRecicipentToArray(event, row) {
    row['checked'] = event?.checked;
    this.dialogboxData.data.find(d => d.examineeId == row.examineeId)['checked'] =  event?.checked;
  }

  close(): void {

    const finalPayload = this.dialogboxData.data.filter((value => value?.checked === true));

    // this.notificationService.success('Examinee(s) added to Schedule successfully');
    this.dialogRef.close(0);

  }

  sendRecipient(): void {
    const finalPayload = this.dialogboxData.data.filter((value => value?.checked === true));
    if (finalPayload.length > 0) {
      this.notificationService.success(this.translate.instant('test.addExaminee.errMsg2'));
      this.dialogRef.close(finalPayload);
    } else {
      this.webErrorService.customErrors(this.translate.instant('test.addExaminee.errMsg1'), true, 'warn')
    }
  }

  setPaginatorTranslation(data: any) {
      if(data) {
        this.translate.stream([
          'test.addExaminee.pagination.pageLabel',
          'test.addExaminee.pagination.firstPage',
          'test.addExaminee.pagination.lastPage',
          'test.addExaminee.pagination.nextPage',
          'test.addExaminee.pagination.prevPage'
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
            data.paginator._intl.itemsPerPageLabel = translation['test.addExaminee.pagination.pageLabel'];
            data.paginator._intl.firstPageLabel = translation['test.addExaminee.pagination.firstPage'];
            data.paginator._intl.lastPageLabel = translation['test.addExaminee.pagination.lastPage'];
            data.paginator._intl.nextPageLabel = translation['test.addExaminee.pagination.nextPage'];
            data.paginator._intl.previousPageLabel = translation['test.addExaminee.pagination.prevPage'];

            data.paginator._intl.changes.next();
        });
      }
  }


  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
@NgModule({
  declarations: [
    // AddRecipientDialogboxComponent,
  ],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    FormsModule,
    MatDividerModule
  ]
})
class AddRecipientDialogboxComponentModule {

}
